export default "__VITE_ASSET__DfhpfIdd__"